// extracted by mini-css-extract-plugin
export default {"container":"ActiveMedicationSection_container__Foc6-","renewalTag":"ActiveMedicationSection_renewalTag__xNlZ5","expired":"ActiveMedicationSection_expired__HjteM"};